class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.generateRecommendations();
  }

  generateRecommendations() {
    const cartForm = document.getElementById('AjaxCartForm');
    if (!cartForm) return;

    const cartItems = cartForm.querySelectorAll('[data-js-cart-item]');
    if (!cartItems.length) return;

    /* ── Collect cart product IDs (to exclude them from recommendations) ── */
    const cartProductIds = [];
    cartItems.forEach(item => {
      if (item.dataset.productId) {
        cartProductIds.push(item.dataset.productId.toString());
      }
    });

    /* Use first cart item as seed for recommendations */
    const seedProductId = cartItems[0].dataset.productId;

    fetch(
      `${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${seedProductId}&limit=${this.dataset.limit}`
    )
      .then(res => res.text())
      .then(text => {
        const parsed    = new DOMParser().parseFromString(text, 'text/html');
        const container = parsed.querySelector('[data-js-cart-recommendations-performed]');

        if (!container) return;

        /* ── Remove products already in cart ── */
        container.querySelectorAll('[data-js-product-item]').forEach(item => {
          const dataProductId = (item.getAttribute('data-product-id') || '').trim();

          if (dataProductId && cartProductIds.includes(dataProductId)) {
            item.remove();
          }
        });

        /* ── Only render if something remains ── */
        if (container.querySelectorAll('[data-js-product-item]').length > 0) {
          this.innerHTML = container.innerHTML;
          this._attachListeners();
        }
      })
      .catch(err => console.error('CartRecommendations fetch error:', err));
  }

  /* ── Button text state helper ── */
  _setButtonState(btn, state) {
    const textEl = btn.querySelector('.button__text');
    if (!textEl) return;

    btn.setAttribute('data-state', state);

    if (state === 'adding') {
      textEl.textContent = btn.dataset.txtAdding || 'Adding...';
      btn.disabled = true;
    } else if (state === 'added') {
      textEl.textContent = btn.dataset.txtAdded || 'Added ✓';
      btn.disabled = true;
      btn.style.cssText = 'background-color:#2a7a3b!important;border-color:#2a7a3b!important;color:#fff!important';
    } else {
      textEl.textContent = btn.dataset.txtDefault || 'Add to Cart';
      btn.removeAttribute('data-state');
      btn.disabled = false;
      btn.style.cssText = '';
    }
  }

  /* ── Refresh cart UI ── */
  _refreshCartUI() {
    if (typeof window.refreshCart === 'function') window.refreshCart();

    const cartFormEl = document.querySelector('#AjaxCartForm');
    if (cartFormEl && typeof cartFormEl.ajaxifyCartItems === 'function') {
      cartFormEl.ajaxifyCartItems();
    }
  }

  /* ── Attach ATC listeners ── */
  _attachListeners() {
    this.querySelectorAll('.js-rec-atc').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();

        const variantId = btn.getAttribute('data-variant-id');
        if (!variantId || btn.disabled) return;

        /* State → Adding */
        this._setButtonState(btn, 'adding');

        const onSuccess = () => {
          this._setButtonState(btn, 'added');
          this._refreshCartUI();
          /* Auto-reset after 2 seconds */
          setTimeout(() => this._setButtonState(btn, 'default'), 2000);
        };

        const onError = err => {
          console.error('ATC error:', err);
          this._setButtonState(btn, 'default');
        };

        /* Theme addToCart OR fetch fallback */
        if (typeof window.addToCart === 'function') {
          const result = window.addToCart(parseInt(variantId), 1, onSuccess);
          if (result && typeof result.then === 'function') {
            result.then(onSuccess).catch(onError);
          }
        } else {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
          })
            .then(res => {
              if (!res.ok) throw new Error('Cart add failed');
              return res.json();
            })
            .then(onSuccess)
            .catch(onError);
        }
      });
    });
  }
}

customElements.define('cart-recommendations', CartRecommendations);
